function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { Switch as SwitchDefault } from 'react-router-dom';
import React from 'react';
import { buildPathname } from 'srcJs/helpers/LanguageHelper';
import app from 'srcJs/App';

var Switch = function Switch(_ref) {
  var children = _ref.children;

  var renderRoute = function renderRoute(route) {
    if (! /*#__PURE__*/React.isValidElement(route)) {
      return route;
    }

    var path = route.props.path;
    var pathNew;

    if (Array.isArray(path)) {
      pathNew = path.map(function (pathElement) {
        return buildPathname(pathElement, app.getLang());
      });
    } else {
      pathNew = buildPathname(path, app.getLang());
    }

    return /*#__PURE__*/React.cloneElement(route, _objectSpread(_objectSpread({}, route.props), {}, {
      path: pathNew
    }));
  };

  return /*#__PURE__*/React.createElement(SwitchDefault, null, React.Children.map(children, function (child) {
    return renderRoute(child);
  }));
};

export { Switch };